import '../common.scss';
import './styles.scss';
import { useNavigate } from 'react-router-dom';
import MainScreen from '../../components/MainSreen';
import Prefooter from '../../components/Prefooter';
import Back from '../../assets/about.jpg';
import Leo from '../../assets/leo.png';
import Vic from '../../assets/vic.png';
import Mike from '../../assets/mike.png';
import Rich from '../../assets/rich.png';
import Keenan from '../../assets/keenan.png';
import Ronak from '../../assets/ronak.png';
import Marty from '../../assets/marty.png';
import Img from '../../assets/holding.png';
import { useOutletContext } from 'react-router-dom';

const MainPage = () => {
  const { setFormOpen } = useOutletContext();
  const navigate = useNavigate();

  return (
    <div className='content'>
      <MainScreen
        tag='About Pioneers'
        title={
          <span>
            We believe AI should make <b>recruiting more human, not less</b>
          </span>
        }
        text='Pioneers is building the future of staffing by combining world-class AI technology with deep operational expertise. We help companies find exceptional talent, and we help staffing agency owners unlock their next chapter.'
        button='Contact us'
        image={Back}
        onClick={() => setFormOpen('Looking to hire talent')}
      />
      <div className='missionBlock'>
        <div className='missionCards'>
          <div className='missionCard'>
            <span className='missionCardCount'>6</span>
            <span className='missionCardText'>Staffing verticals served</span>
          </div>
          <div className='missionCard'>
            <span className='missionCardCount'>6 hrs</span>
            <span className='missionCardText'>Time to first candidates</span>
          </div>
          <div className='missionCard'>
            <span className='missionCardCount'>+50%</span>
            <span className='missionCardText'>Fill rate improvement</span>
          </div>
          <div className='missionCard'>
            <span className='missionCardCount'>60 days</span>
            <span className='missionCardText'>Platform deployment</span>
          </div>
        </div>
        <div className='missionContent'>
          <span className='missionContentTag'>OUR MISSION</span>
          <span className='missionContentTitle'>Building the future of staffing</span>
          <span className='missionContentText'>
            We started Pioneers because we saw an industry stuck between two bad options: impersonal automation or expensive, slow
            manual processes. We believed there was a better way.
            <br />
            <br />
            Our approach combines purpose-built AI with experienced recruiters and operators. Technology handles the repetitive
            work (sourcing, screening, compliance) so humans can focus on what they do best: building relationships and making
            judgment calls.
            <br />
            <br />
            We serve companies looking for exceptional talent and staffing agencies ready to grow with AI. Both deserve a partner,
            not just a vendor.
          </span>
        </div>
      </div>
      <div className='cardsSection'>
        <span className='sectionTitle'>What drives us</span>
        <div className='cardsSectionRow'>
          <div className='cardsSectionItem'>
            <span className='cardsSectionItemIcon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'>
                <path
                  d='M28.6475 21.6251C28.7475 21.7968 28.7752 22.0012 28.7246 22.1934C28.674 22.3856 28.5491 22.5498 28.3775 22.6501L16.3775 29.6501C16.2635 29.7159 16.1342 29.7505 16.0025 29.7505C15.8708 29.7505 15.7415 29.7159 15.6275 29.6501L3.6275 22.6501C3.46992 22.5438 3.35855 22.3817 3.31591 22.1965C3.27326 22.0113 3.30252 21.8168 3.39777 21.6523C3.49302 21.4879 3.64715 21.3657 3.82902 21.3105C4.01089 21.2553 4.20692 21.2712 4.3775 21.3551L16.0025 28.1338L27.6275 21.3551C27.7988 21.2566 28.002 21.2298 28.193 21.2804C28.384 21.3309 28.5473 21.4548 28.6475 21.6251ZM27.625 15.3526L16 22.1313L4.375 15.3526C4.20442 15.2688 4.00839 15.2528 3.82652 15.308C3.64465 15.3632 3.49052 15.4854 3.39527 15.6498C3.30002 15.8143 3.27076 16.0088 3.31341 16.194C3.35605 16.3792 3.46742 16.5413 3.625 16.6476L15.625 23.6476C15.739 23.7134 15.8683 23.748 16 23.748C16.1317 23.748 16.261 23.7134 16.375 23.6476L28.375 16.6476C28.5326 16.5413 28.6439 16.3792 28.6866 16.194C28.7292 16.0088 28.7 15.8143 28.6047 15.6498C28.5095 15.4854 28.3553 15.3632 28.1735 15.308C27.9916 15.2528 27.7956 15.2688 27.625 15.3526ZM3.25 10.0001C3.25035 9.86875 3.28518 9.73983 3.35098 9.6262C3.41679 9.51257 3.51128 9.41821 3.625 9.35256L15.625 2.35256C15.739 2.28673 15.8683 2.25208 16 2.25208C16.1317 2.25208 16.261 2.28673 16.375 2.35256L28.375 9.35256C28.4881 9.41865 28.5819 9.5132 28.647 9.6268C28.7122 9.7404 28.7465 9.86909 28.7465 10.0001C28.7465 10.131 28.7122 10.2597 28.647 10.3733C28.5819 10.4869 28.4881 10.5815 28.375 10.6476L16.375 17.6476C16.261 17.7134 16.1317 17.748 16 17.748C15.8683 17.748 15.739 17.7134 15.625 17.6476L3.625 10.6476C3.51128 10.5819 3.41679 10.4875 3.35098 10.3739C3.28518 10.2603 3.25035 10.1314 3.25 10.0001ZM5.48875 10.0001L16 16.1313L26.5112 10.0001L16 3.87506L5.48875 10.0001Z'
                  fill='#003733'
                />
              </svg>
            </span>
            <span className='cardsSectionItemTitle'>Human-First AI</span>
            <span className='cardsSectionItemText'>
              Technology amplifies people, never replaces them. Your team always has the final say.
            </span>
          </div>

          <div className='cardsSectionItem'>
            <span className='cardsSectionItemIcon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'>
                <path
                  d='M28.6475 21.6251C28.7475 21.7968 28.7752 22.0012 28.7246 22.1934C28.674 22.3856 28.5491 22.5498 28.3775 22.6501L16.3775 29.6501C16.2635 29.7159 16.1342 29.7505 16.0025 29.7505C15.8708 29.7505 15.7415 29.7159 15.6275 29.6501L3.6275 22.6501C3.46992 22.5438 3.35855 22.3817 3.31591 22.1965C3.27326 22.0113 3.30252 21.8168 3.39777 21.6523C3.49302 21.4879 3.64715 21.3657 3.82902 21.3105C4.01089 21.2553 4.20692 21.2712 4.3775 21.3551L16.0025 28.1338L27.6275 21.3551C27.7988 21.2566 28.002 21.2298 28.193 21.2804C28.384 21.3309 28.5473 21.4548 28.6475 21.6251ZM27.625 15.3526L16 22.1313L4.375 15.3526C4.20442 15.2688 4.00839 15.2528 3.82652 15.308C3.64465 15.3632 3.49052 15.4854 3.39527 15.6498C3.30002 15.8143 3.27076 16.0088 3.31341 16.194C3.35605 16.3792 3.46742 16.5413 3.625 16.6476L15.625 23.6476C15.739 23.7134 15.8683 23.748 16 23.748C16.1317 23.748 16.261 23.7134 16.375 23.6476L28.375 16.6476C28.5326 16.5413 28.6439 16.3792 28.6866 16.194C28.7292 16.0088 28.7 15.8143 28.6047 15.6498C28.5095 15.4854 28.3553 15.3632 28.1735 15.308C27.9916 15.2528 27.7956 15.2688 27.625 15.3526ZM3.25 10.0001C3.25035 9.86875 3.28518 9.73983 3.35098 9.6262C3.41679 9.51257 3.51128 9.41821 3.625 9.35256L15.625 2.35256C15.739 2.28673 15.8683 2.25208 16 2.25208C16.1317 2.25208 16.261 2.28673 16.375 2.35256L28.375 9.35256C28.4881 9.41865 28.5819 9.5132 28.647 9.6268C28.7122 9.7404 28.7465 9.86909 28.7465 10.0001C28.7465 10.131 28.7122 10.2597 28.647 10.3733C28.5819 10.4869 28.4881 10.5815 28.375 10.6476L16.375 17.6476C16.261 17.7134 16.1317 17.748 16 17.748C15.8683 17.748 15.739 17.7134 15.625 17.6476L3.625 10.6476C3.51128 10.5819 3.41679 10.4875 3.35098 10.3739C3.28518 10.2603 3.25035 10.1314 3.25 10.0001ZM5.48875 10.0001L16 16.1313L26.5112 10.0001L16 3.87506L5.48875 10.0001Z'
                  fill='#003733'
                />
              </svg>
            </span>
            <span className='cardsSectionItemTitle'>Growth Mindset</span>
            <span className='cardsSectionItemText'>
              We invest in making businesses bigger, not leaner. More placements, better fill rates, higher revenue.
            </span>
          </div>

          <div className='cardsSectionItem'>
            <span className='cardsSectionItemIcon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'>
                <path
                  d='M28.6475 21.625C28.7475 21.7968 28.7752 22.0012 28.7246 22.1934C28.674 22.3855 28.5491 22.5498 28.3775 22.65L16.3775 29.65C16.2635 29.7158 16.1342 29.7505 16.0025 29.7505C15.8708 29.7505 15.7415 29.7158 15.6275 29.65L3.6275 22.65C3.46992 22.5437 3.35855 22.3816 3.31591 22.1964C3.27326 22.0112 3.30252 21.8167 3.39777 21.6523C3.49302 21.4878 3.64715 21.3656 3.82902 21.3104C4.01089 21.2553 4.20692 21.2712 4.3775 21.355L16.0025 28.1337L27.6275 21.355C27.7988 21.2566 28.002 21.2297 28.193 21.2803C28.384 21.3309 28.5473 21.4547 28.6475 21.625ZM27.625 15.3525L16 22.1312L4.375 15.3525C4.20442 15.2687 4.00839 15.2528 3.82652 15.308C3.64465 15.3631 3.49052 15.4853 3.39527 15.6498C3.30002 15.8142 3.27076 16.0087 3.31341 16.1939C3.35605 16.3791 3.46742 16.5412 3.625 16.6475L15.625 23.6475C15.739 23.7133 15.8683 23.748 16 23.748C16.1317 23.748 16.261 23.7133 16.375 23.6475L28.375 16.6475C28.5326 16.5412 28.6439 16.3791 28.6866 16.1939C28.7292 16.0087 28.7 15.8142 28.6047 15.6498C28.5095 15.4853 28.3553 15.3631 28.1735 15.308C27.9916 15.2528 27.7956 15.2687 27.625 15.3525ZM3.25 10C3.25035 9.86869 3.28518 9.73977 3.35098 9.62614C3.41679 9.51251 3.51128 9.41815 3.625 9.3525L15.625 2.35249C15.739 2.28667 15.8683 2.25201 16 2.25201C16.1317 2.25201 16.261 2.28667 16.375 2.35249L28.375 9.3525C28.4881 9.41859 28.5819 9.51314 28.647 9.62674C28.7122 9.74034 28.7465 9.86902 28.7465 10C28.7465 10.131 28.7122 10.2597 28.647 10.3733C28.5819 10.4869 28.4881 10.5814 28.375 10.6475L16.375 17.6475C16.261 17.7133 16.1317 17.748 16 17.748C15.8683 17.748 15.739 17.7133 15.625 17.6475L3.625 10.6475C3.51128 10.5818 3.41679 10.4875 3.35098 10.3739C3.28518 10.2602 3.25035 10.1313 3.25 10ZM5.48875 10L16 16.1312L26.5112 10L16 3.87499L5.48875 10Z'
                  fill='#003733'
                />
              </svg>
            </span>
            <span className='cardsSectionItemTitle'>Transparency</span>
            <span className='cardsSectionItemText'>No black boxes. We explain how our AI works and share results openly.</span>
          </div>

          <div className='cardsSectionItem'>
            <span className='cardsSectionItemIcon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'>
                <path
                  d='M28.6475 21.625C28.7475 21.7968 28.7752 22.0012 28.7246 22.1934C28.674 22.3855 28.5491 22.5498 28.3775 22.65L16.3775 29.65C16.2635 29.7158 16.1342 29.7505 16.0025 29.7505C15.8708 29.7505 15.7415 29.7158 15.6275 29.65L3.6275 22.65C3.46992 22.5437 3.35855 22.3816 3.31591 22.1964C3.27326 22.0112 3.30252 21.8167 3.39777 21.6523C3.49302 21.4878 3.64715 21.3656 3.82902 21.3104C4.01089 21.2553 4.20692 21.2712 4.3775 21.355L16.0025 28.1337L27.6275 21.355C27.7988 21.2566 28.002 21.2297 28.193 21.2803C28.384 21.3309 28.5473 21.4547 28.6475 21.625ZM27.625 15.3525L16 22.1312L4.375 15.3525C4.20442 15.2687 4.00839 15.2528 3.82652 15.308C3.64465 15.3631 3.49052 15.4853 3.39527 15.6498C3.30002 15.8142 3.27076 16.0087 3.31341 16.1939C3.35605 16.3791 3.46742 16.5412 3.625 16.6475L15.625 23.6475C15.739 23.7133 15.8683 23.748 16 23.748C16.1317 23.748 16.261 23.7133 16.375 23.6475L28.375 16.6475C28.5326 16.5412 28.6439 16.3791 28.6866 16.1939C28.7292 16.0087 28.7 15.8142 28.6047 15.6498C28.5095 15.4853 28.3553 15.3631 28.1735 15.308C27.9916 15.2528 27.7956 15.2687 27.625 15.3525ZM3.25 10C3.25035 9.86869 3.28518 9.73977 3.35098 9.62614C3.41679 9.51251 3.51128 9.41815 3.625 9.3525L15.625 2.35249C15.739 2.28667 15.8683 2.25201 16 2.25201C16.1317 2.25201 16.261 2.28667 16.375 2.35249L28.375 9.3525C28.4881 9.41859 28.5819 9.51314 28.647 9.62674C28.7122 9.74034 28.7465 9.86902 28.7465 10C28.7465 10.131 28.7122 10.2597 28.647 10.3733C28.5819 10.4869 28.4881 10.5814 28.375 10.6475L16.375 17.6475C16.261 17.7133 16.1317 17.748 16 17.748C15.8683 17.748 15.739 17.7133 15.625 17.6475L3.625 10.6475C3.51128 10.5818 3.41679 10.4875 3.35098 10.3739C3.28518 10.2602 3.25035 10.1313 3.25 10ZM5.48875 10L16 16.1312L26.5112 10L16 3.87499L5.48875 10Z'
                  fill='#003733'
                />
              </svg>
            </span>
            <span className='cardsSectionItemTitle'>Partnership</span>
            <span className='cardsSectionItemText'>
              Whether you're hiring talent or growing your agency, we succeed when you succeed.
            </span>
          </div>
        </div>
      </div>
      <div className='leadershipSection'>
        <span className='sectionTitle'>Meet our leadership</span>
        <span className='sectionTitleText'>
          Experts in operations, technology, and staffing. We've built leading players in the space before.
        </span>
        <div className='leadershipSectionRow'>
          <div className='leadershipItem'>
            <span className='leadershipItemImage'>
              <img src={Leo} />
            </span>
            <div className='leadershipItemContent'>
              <span className='leadershipItemName'>Leo Shangin</span>
              <span className='leadershipItemRole'>Co-Founder & CEO</span>
              <span className='leadershipItemText'>McKinsey, Rocket Internet. Exited founder scaling services businesses.</span>
            </div>
          </div>

          <div className='leadershipItem'>
            <span className='leadershipItemImage'>
              <img src={Vic} />
            </span>
            <div className='leadershipItemContent'>
              <span className='leadershipItemName'>Victor Novikov</span>
              <span className='leadershipItemRole'>Co-Founder & CPO</span>
              <span className='leadershipItemText'>Google, JPMorgan. Built AI matching and search products at scale.</span>
            </div>
          </div>

          <div className='leadershipItem'>
            <span className='leadershipItemImage'>
              <img src={Mike} />
            </span>
            <div className='leadershipItemContent'>
              <span className='leadershipItemName'>Mike Fitzgerald</span>
              <span className='leadershipItemRole'>Dir, Healthcare Ops</span>
              <span className='leadershipItemText'>25+ yrs healthcare staffing operations and integrations.</span>
            </div>
          </div>
        </div>

        <div className='leadershipSectionRow'>
          <div className='leadershipItem'>
            <span className='leadershipItemImage'>
              <img src={Rich} />
            </span>
            <div className='leadershipItemContent'>
              <span className='leadershipItemName'>Richard Nguyen</span>
              <span className='leadershipItemRole'>Dir, Technology Ops</span>
              <span className='leadershipItemText'>Ex-Robert Half. 20+ yrs staffing ops and turnarounds.</span>
            </div>
          </div>

          <div className='leadershipItem'>
            <span className='leadershipItemImage'>
              <img src={Marty} />
            </span>
            <div className='leadershipItemContent'>
              <span className='leadershipItemName'>Marty Fitzgerald</span>
              <span className='leadershipItemRole'>CEO, American Consultants (Portfolio Company)</span>
              <span className='leadershipItemText'>20+ yrs national healthcare staffing, consulting, and executive search.</span>
            </div>
          </div>

          <div className='leadershipItem'>
            <span className='leadershipItemImage'>
              <img src={Ronak} />
            </span>
            <div className='leadershipItemContent'>
              <span className='leadershipItemName'>Ronak Hakimi</span>
              <span className='leadershipItemRole'>Chief of Staff</span>
              <span className='leadershipItemText'>
                8+ yrs in recruiting and HR operations. Built hiring systems, improved onboarding, and scaled talent programs across the U.S. and Europe.
              </span>
            </div>
          </div>
        </div>

        <div className='leadershipSectionRow'>
          <div className='leadershipItem'>
            <span className='leadershipItemImage'>
              <img src={Keenan} />
            </span>
            <div className='leadershipItemContent'>
              <span className='leadershipItemName'>Keenan Hall</span>
              <span className='leadershipItemRole'>CEO, ToCura Staffing (Portfolio Company)</span>
              <span className='leadershipItemText'>5+ yrs in AI consulting and staffing. Helped companies put AI to work and modernize business operations.</span>
            </div>
          </div>
          </div>
      </div>
      <div className='holdingSection'>
        <div className='holdingName'>
          <span className='holdingNameIcon'>
            <img src={Img} />
          </span>
          <div className='holdingNameInfo'>
            <span className='holdingNameInfoType'>BACKED BY</span>
            <span className='holdingNameInfoText'>Legion Holdings</span>
          </div>
        </div>
        <div className='holdingDetails'>
          <span className='holdingDetailsType'>AI-Native Growth Buyout</span>
          <span className='holdingDetailsText'>In-house AI engineering, operations, and M&A capabilities.</span>
          <span className='holdingDetailsLink' onClick={() => window.open('https://legionholdings.ai/', '_blank')}>
            legionholdings.ai
          </span>
        </div>
      </div>
      <Prefooter
        title='Ready to find your next hire?'
        text={`Tell you who you're looking for. We'll have candidates within two weeks.`}
        button='Contact us'
        onClick={() => setFormOpen('Looking to hire talent')}
      />
    </div>
  );
};

export default MainPage;
